// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nOlNlmv6_4Ayiyr28rMl{width:56px;color:var(--content-primary-tertiary);justify-content:center;align-items:center;display:flex}.eoqVa8m3icJvP8R5w4no{justify-content:center;align-items:center;margin-left:20px;display:flex}.ZCPmCO07io8q9rGZAoiY{white-space:nowrap;text-align:center;min-width:56px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scalePercent": `nOlNlmv6_4Ayiyr28rMl`,
	"counterWrap": `eoqVa8m3icJvP8R5w4no`,
	"counter": `ZCPmCO07io8q9rGZAoiY`
};
export default ___CSS_LOADER_EXPORT___;
